// noinspection GraphQLUnresolvedReference,DuplicatedCode

import axios from 'axios'
import { gql } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'

const gqlQuery = gql`
  mutation ARTICULO_IMPORTAR_ACTUALIZAR($cds: Int!, $file: Upload!) {
    articuloImportarActualizar(cds: $cds, file: $file) {
      estado
      success
      estadisticas {
        codigo
        descripcion
      }
      detalle {
        fila
        columna
        errores
      }
    }
  }
`

/**
 * @description Importación de imagen al articulo
 * @param file
 */
export const apiArticuloImportarActualizar = async (
  file: File,
): Promise<{
  estado: string
  success: boolean
  estadisticas: { codigo: string; descripcion: string }[]
  detalle: { fila: string; columna: string; errores: string[] }[]
}> => {
  // try {
  // const client = new GraphQLClient(import.meta.env.ISI_API_URL)
  const token = localStorage.getItem(AccessToken)
  const cds = 1

  // 1. Preparamos la operación GraphQL según el spec de Multipart Request
  const operations = JSON.stringify({
    query: gqlQuery,
    variables: { cds, file: null },
  })

  const map = JSON.stringify({ '0': ['variables.file'] })
  const formData = new FormData()
  formData.append('operations', operations)
  formData.append('map', map)
  formData.append('0', file)

  try {
    const { data } = await axios.post(import.meta.env.ISI_API_URL, formData, {
      headers: {
        authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    })

    if (data.errors) {
      if (Array.isArray(data.errors)) {
        throw Error(data.errors[0].message)
      }
      throw new Error(data.errors || data.errors.message)
    }

    return data.data.articuloImportarActualizar
  } catch (error: any) {
    // Si axios falla o el backend devuelve errores de GQL
    throw new MyGraphQlError(error)
  }
}
